var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$root.background,attrs:{"id":"app"}},[_c('router-view'),_c('nav',{class:{ [_vm.$root.background]: true, transparent: _vm.$root.hideNav }},[_c('ul',_vm._l((_vm.nav),function(page){return _c('li',{key:page},[_c('router-link',{attrs:{"to":{ name: page }}},[_vm._v(" "+_vm._s(_vm.makeTitle(page))+" ")])],1)}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }